import { Component } from '@angular/core';
import { resourceServerUrl } from './common/constants/auth-keys';

@Component({
  selector: 'app',
  template: ` <router-outlet></router-outlet>   
              <!--<ngrx-store-log-monitor toggleCommand="ctrl-h" positionCommand="ctrl-m"></ngrx-store-log-monitor>-->
            `
})
export class AppComponent {
  constructor() {
    this.loadScript();
  }

  loadScript() {
    let node = document.createElement('script');
    node.src = `${resourceServerUrl}/signalr/hubs`;
    node.type = 'text/javascript';
    node.async = false;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}
